var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74001 9.17498L5.29001 10.375C5.49001 10.575 5.94001 10.675 6.24001 10.675H8.14001C8.74001 10.675 9.39001 10.225 9.54001 9.62498L10.74 5.97498C10.99 5.27498 10.54 4.67498 9.79001 4.67498H7.79001C7.49001 4.67498 7.24001 4.42498 7.29001 4.07498L7.54001 2.47498C7.64001 2.02498 7.34001 1.52498 6.89001 1.37498C6.49001 1.22498 5.99001 1.42498 5.79001 1.72498L3.74001 4.77498",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19 9.17495V4.27495C1.19 3.57495 1.49 3.32495 2.19 3.32495H2.69C3.39 3.32495 3.69 3.57495 3.69 4.27495V9.17495C3.69 9.87495 3.39 10.125 2.69 10.125H2.19C1.49 10.125 1.19 9.87495 1.19 9.17495Z",
    stroke: "#4B5563",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "c29e01c1fe34dcec4ef983b04b869349.svg";
export { ForwardRef as ReactComponent };